// admin/components/PrivateRoute.tsx
import React, { ReactNode } from 'react'
import { Navigate, useLocation } from "react-router-dom";
import { useAppSelector } from "../../State/Store";
type Props = { children: ReactNode; requiredRole?: string };

export default function PrivateRoute({ children, requiredRole }: Props) {
  const { loading, isLoggedIn, roles } = useAppSelector(s => s.auth);
  const location = useLocation();

  const rolesLoaded = roles !==null;

  // While auth/roles are not ready, render something (or null)
  if (loading || (requiredRole && !rolesLoaded)) {
    return <div>Loading...</div>;     // or return null;
  }

  if (!isLoggedIn) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (requiredRole && !roles!.includes(requiredRole)) {
    return <Navigate to="/" replace />;
  }

  return children;
}
